/** Shared headline for landing, /pricing, and paywall marketing headers. */
export const MARKETING_HERO_TITLE = "The Jobs You Won't Find on LinkedIn or Indeed.";

/** Career-page sourcing + unlock → tailor → track workflow. */
export const MARKETING_HERO_SUBTITLE_FALLBACK =
  "Roles sourced from company career pages — unlock the company, tailor your application, and track every move.";

/** Fragment after the highlighted job title in personalized hero subtitles (paywall, etc.). */
export const MARKETING_HERO_SUBTITLE_AFTER_ROLE =
  "— unlock the company, apply direct, and tailor your resume for this role.";

/** Mobile paywall outcome headline (Terms-safe: career-page sourcing, not “before public”). */
export const PAYWALL_MOBILE_HEADLINE =
  "Unlock this company, apply direct, and tailor for this role.";

export const PAYWALL_COMPANY_HIDDEN = "Company hidden until unlock";

export const TEASER_UNLOCK_CTA = "Unlock company & apply link — start free trial";
export const TEASER_UNLOCK_SUB = "2-day free trial · cancel anytime";
export const TEASER_VEIL_TITLE = "Full posting locked";
export const TEASER_VEIL_BODY =
  "Company, description, requirements, and direct apply unlock with a free trial.";
export const TEASER_COMPANY_HIDDEN = "Company hidden — unlock to see who's hiring";

/** Outcome checklist for PaywallUnlockValue. */
export const UNLOCK_OUTCOME_ITEMS = [
  "See the company hiring for this role",
  "Read the full posting and requirements",
  "Apply on the company career page",
  "Tailor resume + cover letter for this job",
  "Track the application end-to-end",
];

/** Pricing page how-it-works steps. */
export const PRICING_HOW_IT_WORKS = [
  { title: "Find a hidden role", body: "Browse roles sourced from company career pages." },
  { title: "Unlock company + apply link", body: "See who’s hiring and apply on their site." },
  { title: "Tailor resume / cover letter", body: "AI-prep your application for that exact job." },
  { title: "Track the application", body: "Keep every opportunity moving in your tracker." },
];

export const PRICING_TRUST_CHIPS = [
  "Sourced from company career pages",
  "Updated daily",
  "Direct apply links",
  "Cancel anytime · Stripe-secured",
];

/** @param {string} [jobTitle] trim(); empty uses fallback string in UI */
export function marketingHeroSubtitleParts(jobTitle) {
  const role = typeof jobTitle === "string" ? jobTitle.trim() : "";
  if (role) return { personalized: true, role };
  return { personalized: false };
}
